import { useQuery } from '@tanstack/react-query';
import { queryKeys, sdk } from 'utils/query';

export const getGeneralConfiguration = async () => {
  return await sdk.configurations.general.get();
};

export const useGetGeneralConfiguration = () => {
  return useQuery({
    queryKey: [queryKeys.generalConfiguration],
    queryFn: getGeneralConfiguration,
    staleTime: Infinity,
  });
};
